
module.exports = {
   //docUrl: 'http://192.168.16.224:8083'
  docUrl: 'https://www.reachxm.com/showdoc'
}
